
/// using jonas css which can be modified ///



export const hideAlert = () => {

	const el = document.querySelector('.alert');

	if (el) el.parentElement.removeChild(el);

};


/// type is success or error, from response

export const showAlert = (type, msg) => {

	hideAlert();

	const markup = `<div class="alert alert--${type}">${msg}</div>`

	document.querySelector('body').insertAdjacentHTML('afterbegin', markup);

	window.setTimeout(hideAlert, 5000);
};

